import { fetchWithApiKey } from "../../helpers/fetch";
import { types } from "../../types/types"

export const keyUnitsStartLoading = () => {
  return async(dispatch) => {
    const resp = await fetchWithApiKey('api/Catalogs/c_ClaveUnidades');
    const body = await resp.json();
    if (body.success){
      dispatch(keyUnitsLoaded(body.data)); 
    }
  }
}

const keyUnitsLoaded = (unitTypes) => ({
  type: types.unitTypesStartLoading,
  payload: unitTypes
})